

import React, { useState } from 'react';
import {
  Button,
  Container,
  FormControl,
  InputLabel,
  Box,
  Modal,
  MenuItem,
  Select,
  TextField,
  Typography,
  Checkbox,
  FormControlLabel,
  useTheme,
  styled,
  Tooltip,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const CustomTableScrollbar = styled('div')(({ theme }) => ({
  overflowY: 'auto',
  backgroundColor: theme.palette.background.paper,
  '&::-webkit-scrollbar': {
    width: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const AddSalaryHead = () => {
  const theme = useTheme();
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [salaryHeadType, setSalaryHeadType] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
const [snackbarMessage, setSnackbarMessage] = useState('');
const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [salaryHeadName, setSalaryHeadName] = useState('');
  const [processSequence, setProcessSequence] = useState('');
  const [value, setValue] = useState('');
  const [selectValueBy, setSelectValueBy] = useState('');
  const [formula, setFormula] = useState('');
  const [allowManualOverride, setAllowManualOverride] = useState(false);

  const navigate = useNavigate();

  // Static data for dropdowns
  const salaryHeadTypes = [
    { id: 1, name: 'Earnings' },
    { id: 2, name: 'Deductions' },
  ];

  const valueByOptions = [
    { id: 1, name: 'System' },
    { id: 2, name: 'User' },
  ];

  const handleSave = (e) => {
    e.preventDefault();
    if (salaryHeadType && salaryHeadName && processSequence && value && selectValueBy && formula) {
    setShowSuccessModal(true)
    } else {
      setSnackbarMessage('plz fill rquired field!');  
  setOpenSnackbar(true);  
  setSnackbarSeverity("error");
    }
  };

  const handleCancel = () => {
    setSalaryHeadType('');
    setSalaryHeadName('');
    setProcessSequence('');
    setValue('');
    setSelectValueBy('');
    setFormula('');
    setAllowManualOverride(false);
  };

  return (
    <Container maxWidth="lg" sx={{ my: 0 }}>
      <Box
        sx={{
          p: 4,
          borderRadius: 2,
          backgroundColor: theme.palette.background.paper,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
            Add Salary Head
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          <FormControl
            fullWidth
            sx={{
              mb: 3,
              '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
            }}
          >
            <InputLabel
              id="salary-head-type-label"
              sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}
            >
              Salary Head Type
            </InputLabel>
            <Select
              labelId="salary-head-type-label"
              id="salary-head-type"
              value={salaryHeadType}
              label="Salary Head Type"
              onChange={(e) => setSalaryHeadType(e.target.value)}
            >
              {salaryHeadTypes.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Salary Head Name"
            variant="outlined"
            fullWidth
            value={salaryHeadName}
            onChange={(e) => setSalaryHeadName(e.target.value)}
            sx={{
              mb: 3,
              '& .MuiInputLabel-root': { color: theme.palette.text.primary },
              '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
            }}
          />
          <TextField
            label="Process Sequence"
            variant="outlined"
            fullWidth
            value={processSequence}
            onChange={(e) => setProcessSequence(e.target.value)}
            sx={{
              mb: 3,
              '& .MuiInputLabel-root': { color: theme.palette.text.primary },
              '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
            }}
          />
          <TextField
            label="Value"
            variant="outlined"
            fullWidth
            value={value}
            onChange={(e) => setValue(e.target.value)}
            sx={{
              mb: 3,
              '& .MuiInputLabel-root': { color: theme.palette.text.primary },
              '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
            }}
          />
          <FormControl
            fullWidth
            sx={{
              mb: 3,
              '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
            }}
          >
            <InputLabel
              id="select-value-by-label"
              sx={{ color: theme.palette.text.primary, '&.Mui-focused': { color: theme.palette.primary.main } }}
            >
              Select Value By
            </InputLabel>
            <Select
              labelId="select-value-by-label"
              id="select-value-by"
              value={selectValueBy}
              label="Select Value By"
              onChange={(e) => setSelectValueBy(e.target.value)}
            >
              {valueByOptions.map((option) => (
                <MenuItem key={option.id} value={option.id}>
                  {option.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Formula"
            variant="outlined"
            fullWidth
            value={formula}
            onChange={(e) => setFormula(e.target.value)}
            sx={{
              mb: 3,
              '& .MuiInputLabel-root': { color: theme.palette.text.primary },
              '& .MuiInputLabel-root.Mui-focused': { color: theme.palette.primary.main },
              '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.text.primary },
              '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.primary.main },
            }}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={allowManualOverride}
                onChange={(e) => setAllowManualOverride(e.target.checked)}
                sx={{
                  color: theme.palette.text.primary,
                  '&.Mui-checked': { color: theme.palette.text.primary },
                }}
              />
            }
            label="Allow Manually Amount to be Overridden"
            sx={{ mb: 3 }}
          />
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Tooltip
              title={
                !salaryHeadType ? 'Select Salary Head Type' :
                !salaryHeadName ? 'Enter Salary Head Name' :
                !processSequence ? 'Enter Process Sequence' :
                !value ? 'Enter Value' :
                !selectValueBy ? 'Select Value By' :
                !formula ? 'Enter Formula' : ''
              }
              arrow
            >
              <span>
                <Button
                  variant="contained"
                  onClick={handleSave}
                  disabled={!salaryHeadType || !salaryHeadName || !processSequence || !value || !selectValueBy || !formula}
                >
                  SAVE
                </Button>
              </span>
            </Tooltip>
            <Button
              variant="outlined"
              color="error"
              onClick={handleCancel}
            >
              RESET
            </Button>
            <Button onClick={()=>{navigate(-1)}} variant='outlined' color='secondary'>Back</Button>
          </Box>
        </Box>
      </Box>
      <Modal
        open={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
        aria-labelledby="success-modal-title"
        aria-describedby="success-modal-description"
        BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: 400,
            bgcolor: theme.palette.background.paper,
            borderRadius: 2,
            boxShadow: 24,
            overflow: 'hidden',
          }}
        >
          <Box sx={{ backgroundColor: theme.palette.primary.main, padding: '12px 16px' }}>
            <Typography id="success-modal-title" variant="h6" sx={{ color: theme.palette.primary.contrastText }}>
              Salary Head Added ✅
            </Typography>
          </Box>
          <Box sx={{ padding: '20px' }}>
            <Typography id="success-modal-description" sx={{ mb: 2 }}>
              Salary Head Added Successfully
            </Typography>
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
              <Button
                onClick={() => {
                  setShowSuccessModal(false);
                  navigate(-1);
                }}
                variant="contained"
                color="primary"
              >
                OK
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
      <Snackbar
  open={openSnackbar}
  autoHideDuration={4000}
  onClose={() => setOpenSnackbar(false)}
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
>
  <Alert onClose={() => setOpenSnackbar(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
    {snackbarMessage}
  </Alert>
</Snackbar>
    </Container>
  );
};

export default AddSalaryHead;